import Icon from "Components/Icons/Icon";
import CheckMarginModal from "Components/Modals/CheckMarginModal";
import DiscountModal from "Components/Quotes/ManageQuotes/DiscountModal";
import { useState } from "react";
import { InvoiceDetailsPayload } from "types/invoice.api";
import { calculateMarginData } from "utils/utils";

interface InvoiceSummaryTotalsProps {
  invoiceDetails: InvoiceDetailsPayload;
}

const InvoiceSummaryTotals: React.FC<InvoiceSummaryTotalsProps> = ({
  invoiceDetails,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [openAddDiscountModal, setOpenAddDiscountModal] = useState(false);

  const grandTotal = invoiceDetails?.financial_summary?.grand_total || 0;
  const depositApplied = invoiceDetails?.payments?.reduce(
    (total, payment) => total + Number(payment.allocated || 0),
    0
  );
  const grandTotalAfterDeposit = Math.max(grandTotal - depositApplied, 0);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const handleApplyDiscount = (discountPercentage: number) => {
    // dispatch(
    //   editQuote({
    //     quote_id: quotesDetails.id,
    //     updatedBody: { discount: discountPercentage },
    //   })
    // );
    setOpenAddDiscountModal(false);
  };
  return (
    <div
      className="d-flex flex-column gap-2 ms-auto p-3"
      style={{ width: 300 }}
    >
      <CheckMarginModal
        isOpen={showModal}
        onClose={closeModal}
        items={invoiceDetails.items}
      />

      <DiscountModal
        openDiscountModal={openAddDiscountModal}
        toggleDiscountModal={() => {
          setOpenAddDiscountModal((prev) => !prev);
        }}
        addDiscount={handleApplyDiscount}
        discountPercentage={50}
      // onAddDiscountClick={handleApplyDiscount}
      />
      {/* Subtotal */}
      <div className="d-flex justify-content-between w-100 pb-1">
        <div className="text-grey89 fw-normal fs-14 font-primary">Subtotal</div>
        <div className="text-black2D fw-normal fs-14 font-primary">
          £{invoiceDetails?.financial_summary?.sub_total.toFixed(2) || 0}
        </div>
      </div>

      {/* Deposit Applied */}
      {depositApplied > 0 && (
        <div className="d-flex justify-content-between w-100 pb-1">
          <div className="text-grey89 fw-normal fs-14 font-primary">Deposit Applied</div>
          <div className="text-green fw-normal fs-14 font-primary">
            £{depositApplied.toFixed(2)}
          </div>
        </div>
      )}

      {/* Margin */}
      <div className="d-flex justify-content-between w-100">
        <div className="text-grey89 fw-normal fs-14 font-primary">
          Margin (
          {calculateMarginData(
            invoiceDetails.items
          ).totals.totalMarginPercent.toFixed(2)}
          %)
        </div>
        <button
          className="btn p-0 text-primary text-decoration-underline fs-14 font-primary"
          style={{ background: "none" }}
          onClick={openModal}
        >
          Check Margin
        </button>
      </div>

      {/* Tax */}
      <div className="d-flex justify-content-between w-100">
        <div className="text-grey89 fw-normal fs-14 font-primary">
          Tax ({invoiceDetails?.quote?.vat}%)
        </div>
        <div className="text-black2D fw-normal fs-14 font-primary">
          £{invoiceDetails?.financial_summary?.tax.toFixed(2) || 0}
        </div>
      </div>

      {/* Discount */}
      <div className="d-flex justify-content-between w-100">
        <div className="text-grey89 fw-normal fs-14 font-primary">
          Discount ({invoiceDetails?.quote?.discount?.amount || 0}%)
        </div>
        <div className="text-black2D fw-normal fs-14 font-primary">
          £{invoiceDetails.financial_summary.discount.toFixed(2)}
        </div>
      </div>

      {/* Divider */}
      <div className="my-2 dashed" />

      {/* Grand Total */}
      <div className="d-flex justify-content-between w-100 mt-2">
        <div className="text-grey89 fw-medium fs-14 font-primary">
          Grand Total
        </div>
        <div className="text-black2D fw-medium fs-14 font-primary">
          £{grandTotalAfterDeposit.toFixed(2)}
        </div>
      </div>

      {/* Divider */}
      <div className="my-2 dashed" />


      {
        invoiceDetails?.payment_method && <div className="d-flex justify-content-between w-100 mt-1">
          <div className="text-grey89 fw-normal fs-14 font-primary">
            Payment Method
          </div>
          <div className="text-black2D fw-normal fs-14 font-primary">
            {(() => {
              const method = invoiceDetails?.payment_method;
              return method.charAt(0).toUpperCase() + method.slice(1);
            })()}
          </div>
        </div>
      }
      {(invoiceDetails.payment_method) === "cash" && (
        <div className="d-flex gap-2 mt-2 position-relative">
          <Icon name='InfoOrange' width={16} height={16} className="align-self-start position-absolute" />
          <span className="fs-14 text-orangeFF fw-normal text-start ms-4" >
            Cash or offline payments should be completed directly and are not processed online.
          </span>
        </div>
      )}
    </div>
  );
};

export default InvoiceSummaryTotals;
